import { useTranslation } from 'react-i18next';

const images = [
  'https://readdy.ai/api/search-image?query=A%20Quebec%20bungalow%20house%20on%20a%20residential%20street%20with%20brand%20new%20architectural%20asphalt%20shingle%20roof%2C%20summer%20day%2C%20green%20lawn%2C%20mature%20trees%2C%201970s%20architecture%20style%2C%20Saint-Romuald%20suburban%20feel%2C%20warm%20natural%20light%2C%20professional%20photography&width=400&height=300&seq=sr-projet-1&orientation=squarish',
  'https://readdy.ai/api/search-image?query=A%20two-story%20cottage%20house%20with%20new%20standing%20seam%20metal%20roof%20in%20Quebec%20suburban%20neighborhood%2C%20copper%20brown%20metal%20roofing%2C%20white%20siding%2C%20mature%20landscaping%2C%20warm%20afternoon%20light%2C%20clean%20professional%20real%20estate%20photography&width=400&height=300&seq=sr-projet-2&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Close%20up%20of%20roof%20repair%20work%20in%20progress%20on%20a%20Quebec%20bungalow%2C%20new%20asphalt%20shingles%20being%20installed%2C%20professional%20roofing%20tools%20visible%2C%20overcast%20spring%20day%2C%20documentary%20style%20construction%20photography%2C%20authentic%20work%20site&width=400&height=300&seq=sr-projet-3&orientation=squarish',
];

export default function ProjetsRecents() {
  const { t } = useTranslation('saintromuald');

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-manrope font-bold text-slate-primary text-center mb-10 md:mb-14">
          {t('projets_h2')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {[1, 2, 3].map((i) => (
            <div key={i} className="rounded-lg overflow-hidden bg-soft-gray">
              <div className="h-[200px] md:h-[240px] overflow-hidden">
                <img
                  src={images[i - 1]}
                  alt={`projet toiture Saint-Romuald ${i} — couvreur RBQ à Lévis`}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  width="400"
                  height="300"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-base md:text-lg font-manrope font-bold text-slate-primary mb-2">
                  {t(`projet_${i}_title`)}
                </h3>
                <p className="text-sm text-gray-700 leading-relaxed">
                  {t(`projet_${i}_desc`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}